import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import { LOGOUT_USER } from '../../constants/actionconstants';
import auth from '../auth';
import admin from '../admin';
import race from '../race';
import user from '../user';
import globalError from '../globalerror';
import system from '../system';
import initialStoreState from '../../store/initialstorestate';

const rootReducerWithoutLogout = combineReducers({
    routing : routerReducer,
    auth,
    admin,
    race,
    user,
    globalError,
    system,
});

const rootReducer = (state, action) => { // see http://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store
    if (action.type === LOGOUT_USER) {
        const routing = state.routing;
        state = initialStoreState;
        state.routing = routing;
    }

    return rootReducerWithoutLogout(state, action);
};

export default rootReducer;


// WEBPACK FOOTER //
// ./src/client/src/reducers/root/rootreducer.js